module.exports = __webpack_public_path__ + "img/24.547f24af.jpg";